"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulletSquigglyRing = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const settings_1 = require("./settings");
const squiggly_1 = require("./squiggly");
const SQUIGGLY_LOBES = 12;
const SQUIGGLY_AMP = 1.2;
/**
 * Squiggly outline of the bullet disc. Drawn as an SVG so the wavy ring sits
 * flush around the bullet's natural box and lobes don't get clipped.
 */
const BulletSquigglyRing = ({ strokeColor, strokeWidth }) => {
    const padding = SQUIGGLY_AMP + strokeWidth;
    const outerSize = settings_1.INDICATOR_SIZE + padding * 2;
    const center = outerSize / 2;
    const meanRadius = settings_1.INDICATOR_SIZE / 2 - strokeWidth / 2;
    const path = (0, squiggly_1.squigglyCirclePath)(center, meanRadius, SQUIGGLY_LOBES, SQUIGGLY_AMP);
    return (React.createElement("svg", { width: outerSize, height: outerSize, viewBox: `0 0 ${outerSize} ${outerSize}`, "aria-hidden": "true", style: {
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            pointerEvents: 'none',
            overflow: 'visible',
        } },
        React.createElement("path", { d: path, fill: "none", stroke: strokeColor, strokeWidth: strokeWidth })));
};
exports.BulletSquigglyRing = BulletSquigglyRing;
